var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isNotGroup)?_c('v-checkbox',{staticStyle:{"margin":"0px","margin-top":"5px"},attrs:{"color":"primary"},on:{"change":_vm.setCheck},model:{value:(_vm.checkbox),callback:function ($$v) {_vm.checkbox=$$v},expression:"checkbox"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }